import AddCardWrapper from "components/shared/containers/AddCardWrapper";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton, UISecondaryButton } from "components/ui/UIButton";
import React from "react";

/**
 * @function PrivacyPolicyPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PrivacyPolicyPage - This is a Video-Only Component
 */

export default function PrivacyPolicyPage(props) {
  return (
    <AddCardWrapper className="privacy-policy-page">
      <MainContentContainer className="hide-chevron-icon" header={<MainContentHeader text="Privacy Policy"></MainContentHeader>}>
        <p>Our full Privacy Policy will appear here. Please take a moment to review it, then Accept.</p>
        <div className="flex-container flex-horizontal align-center-container column-space-around-container">
          <UISecondaryButton text="Decline" dataPoint="cancel_privacy_button"/>
          <UIPrimaryButton text="Accept" dataPoint="accept_privacy_button"/>
        </div>
      </MainContentContainer>
    </AddCardWrapper>
  );
}